import { render, staticRenderFns } from "./InvitationSentList.vue?vue&type=template&id=2039733d&scoped=true&"
import script from "./InvitationSentList.vue?vue&type=script&lang=js&"
export * from "./InvitationSentList.vue?vue&type=script&lang=js&"
import style0 from "./InvitationSentList.vue?vue&type=style&index=0&id=2039733d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039733d",
  null
  
)

export default component.exports